import React, {useState, useEffect, useRef} from 'react';
import {findEnabledTablesByQueryString} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";

const PdvSaleManagerTable = () => {
    const [tables, setTables] = useState([]);
    const [filteredTables, setFilteredTables] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    function removeSpecialChars(str) {
        return str.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
    }

    async function makeQuery(query) {
        try {
            setLoading(true);
            const data = await findEnabledTablesByQueryString(query);
            const sorted = (data || []).sort((a, b) =>
                removeSpecialChars(a.name).localeCompare(removeSpecialChars(b.name)));
            setTables(sorted);
            setFilteredTables(sorted);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) inputQueryString.current.focus();
        makeQuery('');
    }, []);

    const handleInputChange = (e) => {
        const string = removeSpecialChars(e.target.value).toUpperCase();
        const filtered = tables.filter(f => removeSpecialChars(f.name).toUpperCase().includes(string))
            .sort((a, b) => removeSpecialChars(a.name).localeCompare(removeSpecialChars(b.name)));
        setFilteredTables(filtered);
        setQueryString(string);
    };

    return (
        <>
            <div className="header-label">Mesa</div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                 className="input-container">
                <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                       onChange={handleInputChange} onFocus={(e) => e.target.select()} inputMode="numeric"/>
                <button id="clearButton" onClick={() => { setQueryString(''); inputQueryString.current.focus(); }}>X</button>
            </div>
            <table style={{width: '100%'}}>
                <colgroup>
                    <col style={{width: '500px'}}/>
                    <col style={{width: '50px'}}/>
                </colgroup>
                <thead><tr><th>Nome</th><th/></tr></thead>
                <tbody>
                {filteredTables.map((table, index) => (
                    <tr key={index}>
                        <td><div>{table.name}</div></td>
                        <td>
                            <button onClick={() => {
                                const sale = {table: table};
                                localStorage.setItem('pdvSale', JSON.stringify(sale));
                                navigate('/pdv/customer');
                            }}>Selecionar</button>
                        </td>
                    </tr>
                ))}
                </tbody>
                {tables.length === 0 && <tfoot><tr><td colSpan={2}>Nenhum item encontrado</td></tr></tfoot>}
            </table>
        </>
    );
};

export default PdvSaleManagerTable;
